import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import sqfService from '../services/sqfService';

// Ported verbatim from the old Navbar.js (lines 66-72, 224-241): the end-of-shift
// SQF checklist gate — a persistent banner reminding production staff to complete
// a checklist before closing out, refetched on route change and on production
// status change. Dismissal is per-browser-session (sessionStorage), and overdue
// items (from a prior day) can't be dismissed at all.
export default function useAfterProductionGate(canProduction) {
  const location = useLocation();
  const [afterProductionPending, setAfterProductionPending] = useState([]);
  const [dismissedAfterIds, setDismissedAfterIds] = useState(() => {
    try { return new Set(JSON.parse(sessionStorage.getItem('sqf_after_dismissed') || '[]')); }
    catch { return new Set(); }
  });

  useEffect(() => {
    if (!canProduction) { setAfterProductionPending([]); return; }
    sqfService.getAfterProductionGate()
      .then(r => setAfterProductionPending(r.pending || []))
      .catch(() => setAfterProductionPending([]));
  }, [canProduction, location.pathname]);

  useEffect(() => {
    const handler = () => {
      if (!canProduction) return;
      sqfService.getAfterProductionGate()
        .then(r => setAfterProductionPending(r.pending || []))
        .catch(() => setAfterProductionPending([]));
    };
    window.addEventListener('productionStatusChanged', handler);
    return () => window.removeEventListener('productionStatusChanged', handler);
  }, [canProduction]);

  const visible = afterProductionPending.filter(p => !dismissedAfterIds.has(p.instanceId));

  const dismiss = () => {
    const todayItems = visible.filter(p => !p.overdue);
    if (todayItems.length === 0) return;
    const next = new Set([...dismissedAfterIds, ...todayItems.map(p => p.instanceId)]);
    setDismissedAfterIds(next);
    try { sessionStorage.setItem('sqf_after_dismissed', JSON.stringify([...next])); } catch {}
  };

  const clearAll = () => setAfterProductionPending([]);

  return { visiblePending: visible, dismiss, clearAll };
}
